import { SVGProps } from 'react';

const ImageLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg width="81" height="50" viewBox="0 0 239 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#filter0_i_2160_16)">
      <path d="M0.875 1.9375H10.5V39.7188H33.3125V48H0.875V1.9375Z" fill="#F40000" />
      <path
        d="M79.1875 49.2812C72.6042 49.2812 67.5729 47.4896 64.0938 43.9062C59.4271 39.5104 57.0938 33.1771 57.0938 24.9062C57.0938 16.4688 59.4271 10.1354 64.0938 5.90625C67.5729 2.32292 72.6042 0.53125 79.1875 0.53125C85.7708 0.53125 90.8021 2.32292 94.2812 5.90625C98.9271 10.1354 101.25 16.4688 101.25 24.9062C101.25 33.1771 98.9271 39.5104 94.2812 43.9062C90.8021 47.4896 85.7708 49.2812 79.1875 49.2812ZM88.2812 36.9062C90.5104 34.0938 91.625 30.0938 91.625 24.9062C91.625 19.7396 90.5 15.75 88.25 12.9375C86.0208 10.1042 83 8.6875 79.1875 8.6875C75.375 8.6875 72.3333 10.0938 70.0625 12.9062C67.7917 15.7188 66.6562 19.7188 66.6562 24.9062C66.6562 30.0938 67.7917 34.0938 70.0625 36.9062C72.3333 39.7188 75.375 41.125 79.1875 41.125C83 41.125 86.0312 39.7188 88.2812 36.9062Z"
        fill="#009639"
      />
      <path
        d="M155.688 46.875C153.146 48.4375 150.021 49.2188 146.312 49.2188C140.208 49.2188 135.208 47.1042 131.312 42.875C127.25 38.625 125.219 32.8125 125.219 25.4375C125.219 17.9792 127.271 12 131.375 7.5C135.479 3 140.906 0.75 147.656 0.75C153.51 0.75 158.208 2.23958 161.75 5.21875C165.312 8.17708 167.354 11.875 167.875 16.3125H158.406C157.677 13.1667 155.896 10.9688 153.062 9.71875C151.479 9.03125 149.719 8.6875 147.781 8.6875C144.073 8.6875 141.021 10.0938 138.625 12.9062C136.25 15.6979 135.062 19.9062 135.062 25.5312C135.062 31.1979 136.354 35.2083 138.938 37.5625C141.521 39.9167 144.458 41.0938 147.75 41.0938C150.979 41.0938 153.625 40.1667 155.688 38.3125C157.75 36.4375 159.021 33.9896 159.5 30.9688H148.844V23.2812H168.031V48H161.656L160.688 42.25C158.833 44.4375 157.167 45.9792 155.688 46.875Z"
        fill="#FF8300"
      />
      <path
        d="M216.438 49.2812C209.854 49.2812 204.823 47.4896 201.344 43.9062C196.677 39.5104 194.344 33.1771 194.344 24.9062C194.344 16.4688 196.677 10.1354 201.344 5.90625C204.823 2.32292 209.854 0.53125 216.438 0.53125C223.021 0.53125 228.052 2.32292 231.531 5.90625C236.177 10.1354 238.5 16.4688 238.5 24.9062C238.5 33.1771 236.177 39.5104 231.531 43.9062C228.052 47.4896 223.021 49.2812 216.438 49.2812ZM225.531 36.9062C227.76 34.0938 228.875 30.0938 228.875 24.9062C228.875 19.7396 227.75 15.75 225.5 12.9375C223.271 10.1042 220.25 8.6875 216.438 8.6875C212.625 8.6875 209.583 10.0938 207.312 12.9062C205.042 15.7188 203.906 19.7188 203.906 24.9062C203.906 30.0938 205.042 34.0938 207.312 36.9062C209.583 39.7188 212.625 41.125 216.438 41.125C220.25 41.125 223.281 39.7188 225.531 36.9062Z"
        fill="#F1DE02"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_2160_16"
        x="0.875"
        y="0.53125"
        width="237.625"
        height="52.75"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2160_16" />
      </filter>
    </defs>
  </svg>
);
export default ImageLogo;
